module.exports = __webpack_public_path__ + "static/img/barcode_3.050c025.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/barcode_3.png
// module id = GF8X
// module chunks = 16